import { usePathname } from 'expo-router';

const useOnMainPage = () => {
  const currentRoute = usePathname();
  const isOnMainPage =
    currentRoute === '/' ||
    currentRoute === '/rewards' ||
    currentRoute === '/move-money' ||
    currentRoute === '/myvaro';

  return {
    isOnMainPage,
  };
};

export default useOnMainPage;
